import { useEffect } from "react";

export default function Seo({ title, description, path }) {
  useEffect(() => {
    document.title = title;
    const origin = window.location.origin;
    const url = `${origin}${path}`;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const key = selector.includes("property") ? "property" : "name";
        el.setAttribute(key, selector.match(/["'](.+)["']/)[1]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, path]);

  return null;
}
